module.exports = __webpack_public_path__ + "img/logo-spirit.fdcf72c.svg";